import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const QuoteOpening = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 39 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83984 29.2409C4.67984 29.2409 0.839844 25.1609 0.839844 19.5209C0.839844 9.32091 6.95984 2.0009 17.0398 0.920898V3.2009C11.8798 4.28091 6.11984 9.0809 5.75984 15.6809C12.2398 13.0409 17.0398 17.2409 17.0398 21.6809C17.0398 26.0009 13.9198 29.2409 9.83984 29.2409ZM30.9598 29.2409C25.7998 29.2409 21.9598 25.1609 21.9598 19.5209C21.9598 9.32091 28.0798 2.0009 38.1598 0.920898V3.2009C32.9998 4.28091 27.2398 9.0809 26.8798 15.6809C33.3598 13.0409 38.1598 17.2409 38.1598 21.6809C38.1598 26.0009 35.0398 29.2409 30.9598 29.2409Z"
        fill="currentColor"
      />
    </svg>
  )
})

export default QuoteOpening

QuoteOpening.displayName = 'QuoteOpening'
